import { mapState } from 'pinia';
import { navigateTo } from 'nuxt/app';
import { useUserStore } from '~~/common/stores/user';
import { LT_ECOM } from '~~/common/config/LoginTypeConfig';

export default {
  watch: {
    loginType (newValue, oldValue) {
      // if user login type changed from ecom to other value, then redirect to home page
      if (newValue !== LT_ECOM && oldValue === LT_ECOM) {
        navigateTo(this.$localePath('/'));
      }
    },
  },
  computed: {
    ...mapState(useUserStore, {
      loginType: state => state.loginType,
    }),
  },
};
